import classNames from "classnames";

export default function Wrapper({ component, classes }) {
  return <div className={classNames("wrapper", classes)}>{component}</div>;
}
